export const menuData = [
  {
    name: "首页",
    src1: require("../assets/images/menuIco/1.png"),
    src2: require("../assets/images/menuIco/1-1.png"),
    path: "/",
    children: [],
  },
  {
    name: "合作商管理",
    src1: require("../assets/images/menuIco/2.png"),
    src2: require("../assets/images/menuIco/2-1.png"),
    path: "/partner",
    children: [],
  },
  {
    name: "用户管理",
    src1: require("../assets/images/menuIco/2.png"),
    src2: require("../assets/images/menuIco/2-1.png"),
    path: "/users",
    children: [],
  },
  // {
  //   path: "/contractManagement",
  //   name: "contractManagement",
  //   component: () => import("./views/contractManagement/index.vue"),
  //   meta: {
  //     title: "签约管理",
  //   },
  // },
  // {
  //   path: "/listWorks",
  //   name: "listWorks",
  //   component: () => import("./views/listWorks/index.vue"),
  //   meta: {
  //     title: "作品列表",
  //   },
  // },
  {
    name: "签约管理",
    src1: require("../assets/images/menuIco/3.png"),
    src2: require("../assets/images/menuIco/3-1.png"),
    path: "/contractManagement",
    children: [],
  },
  {
    name: "作品列表",
    src1: require("../assets/images/menuIco/3.png"),
    src2: require("../assets/images/menuIco/3-1.png"),
    path: "/listWorks",
    children: [],
  },
  {
    name: "知识库管理",
    src1: require("../assets/images/menuIco/3.png"),
    src2: require("../assets/images/menuIco/3-1.png"),
    path: "/KBManage",
    children: [],
  },
  {
    name: "店铺管理",
    src1: require("../assets/images/menuIco/3.png"),
    src2: require("../assets/images/menuIco/3-1.png"),
    path: "/shop",
    children: [],
  },
  {
    name: "页面管理",
    src1: require("../assets/images/menuIco/3.png"),
    src2: require("../assets/images/menuIco/3-1.png"),
    children: [
      {
        name: "分类管理",
        path: "/imageCategory",
      },
      {
        name: "标签管理",
        path: "/imageNode",
      },
      {
        name: "节庆热点",
        path: "/holidayHot",
      },
      {
        name: "轮播图",
        path: "/carouselMap",
      },
      {
        name: "展示设置",
        path: "/showSetting",
      },
    ],
  },
  {
    name: "套餐管理",
    src1: require("../assets/images/menuIco/3.png"),
    src2: require("../assets/images/menuIco/3-1.png"),
    children: [
      {
        name: "咨询管理",
        path: "/consultingManagement",
      },
      {
        name: "套餐设置",
        path: "/packageSetting",
      },
      {
        name: "定制套餐",
        path: "/customPackage",
      },
      {
        name: "代理套餐",
        path: "/agencyPackage",
      },
    ],
  },
  {
    name: "交易管理",
    src1: require("../assets/images/menuIco/3.png"),
    src2: require("../assets/images/menuIco/3-1.png"),
    children: [
      {
        name: "订单列表",
        path: "/imageOrder",
      },
      {
        name: "套餐购买",
        path: "/packagePay",
      },
      {
        name: "充值记录",
        path: "/rechargeRecord",
      },
      {
        name: "套餐消费",
        path: "/packageConsumption",
      },
      {
        name: "国版币消费",
        path: "/countryConsumption",
      },
      {
        name: "国版币发放",
        path: "/countryIssue",
      },
    ],
  },
  {
    name: "订单管理",
    src1: require("../assets/images/menuIco/4.png"),
    src2: require("../assets/images/menuIco/4-1.png"),
    path: "/order",
    children: [],
  },
  {
    name: "退款管理",
    src1: require("../assets/images/menuIco/5.png"),
    src2: require("../assets/images/menuIco/5-1.png"),
    path: "/refund",
    children: [],
  },
  {
    name: "结算管理",
    src1: require("../assets/images/menuIco/5.png"),
    src2: require("../assets/images/menuIco/5-1.png"),
    path: "/settlement",
    children: [],
  },
  {
    name: "商品管理",
    src1: require("../assets/images/menuIco/6.png"),
    src2: require("../assets/images/menuIco/6-1.png"),
    children: [
      {
        name: "已审核商品",
        path: "/goodsReviewed",
      },
      {
        name: "待审核商品",
        path: "/goodsNotReviewed",
      },
      {
        name: "批量审核通道",
        path: "/batchGoodsReviewed",
      },
    ],
  },
  {
    name: "作品管理",
    src1: require("../assets/images/menuIco/7.png"),
    src2: require("../assets/images/menuIco/7-1.png"),
    path: "/works",
    children: [],
  },
  {
    name: "普通版权登记管理",
    src1: "el-icon-s-ticket",
    custmaIcon: true,
    path: "/general",
    children: [],
  },
  {
    name: "数字版权管理",
    src1: "el-icon-s-release",
    custmaIcon: true,
    path: "/digitalRights",
    children: [],
  },
  {
    name: "版权维权管理",
    src1: "el-icon-s-management",
    custmaIcon: true,
    path: "/copyrightProtection",
    children: [],
  },
  {
    name: "发票管理",
    src1: "el-icon-s-data",
    custmaIcon: true,
    path: "/bill",
    children: [],
  },
  // {
  // 	name: '提现管理',
  // 	src1: require('../assets/images/menuIco/8.png'),
  // 	src2: require('../assets/images/menuIco/8-1.png'),
  // 	path: '/withdraw',
  // 	children: [],
  // },
  {
    name: "投诉管理",
    src1: require("../assets/images/menuIco/9.png"),
    src2: require("../assets/images/menuIco/9-1.png"),
    path: "/complaint",
    children: [],
  },
  // {
  // 	name: '收益管理',
  // 	src1: require('../assets/images/menuIco/10.png'),
  // 	src2: require('../assets/images/menuIco/10-1.png'),
  // 	path: '/earnings',
  // 	children: [],
  // },
  {
    name: "公告管理",
    src1: require("../assets/images/menuIco/11.png"),
    src2: require("../assets/images/menuIco/11-1.png"),
    path: "/notice",
    children: [],
  },
  {
    name: "意见反馈",
    src1: require("../assets/images/menuIco/8.png"),
    src2: require("../assets/images/menuIco/8-1.png"),
    path: "/suggestion",
    children: [],
  },
  {
    name: "评价管理",
    src1: require("../assets/images/menuIco/12.png"),
    src2: require("../assets/images/menuIco/12-1.png"),
    path: "/evaluate",
    children: [],
  },
  {
    name: "协议管理",
    src1: require("../assets/images/menuIco/12.png"),
    src2: require("../assets/images/menuIco/12-1.png"),
    path: "/agreement",
    children: [],
  },
  {
    name: "分类管理",
    src1: require("../assets/images/menuIco/13.png"),
    src2: require("../assets/images/menuIco/13-1.png"),
    children: [
      {
        name: "商品类型管理",
        path: "/goodsType",
      },
      {
        name: "后台商品分类",
        path: "/backstageClass",
      },
      {
        name: "前台商品分类",
        path: "/receptionClass",
      },
    ],
  },
  {
    name: "属性管理",
    src1: require("../assets/images/menuIco/14.png"),
    src2: require("../assets/images/menuIco/14-1.png"),
    children: [
      {
        name: "商品属性管理",
        path: "/goodsAttribute",
      },
      {
        name: "定价属性管理",
        path: "/priceAttribute",
      },
    ],
  },
  {
    name: "系统管理",
    src1: require("../assets/images/menuIco/15.png"),
    src2: require("../assets/images/menuIco/15-1.png"),
    children: [
      {
        name: "业务数据",
        path: "/echarts",
      },
      {
        name: "角色管理",
        path: "/role",
      },
      {
        name: "管理员管理",
        path: "/administrators",
      },
      // {
      // 	name: '权益管理',
      // 	path: '/rights',
      // },
      {
        name: "消息管理",
        path: "/message",
      },
      {
        name: "文章管理",
        path: "/article",
      },
      {
        name: "系统日志",
        path: "/journal",
      },
      {
        name: "平台商城管理",
        path: "/mallAdministration",
      },
    ],
  },
];
